import { render, staticRenderFns } from "./ClinicBusinessFee.vue?vue&type=template&id=93e95026&scoped=true"
import script from "./ClinicBusinessFee.vue?vue&type=script&lang=js"
export * from "./ClinicBusinessFee.vue?vue&type=script&lang=js"
import style0 from "./ClinicBusinessFee.vue?vue&type=style&index=0&id=93e95026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e95026",
  null
  
)

export default component.exports